
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PageTemplate, { Lang } from '../../../components/layout/PageTemplate';
import en from '../../../locales/en.json';
import mk from '../../../locales/mk.json';
import al from '../../../locales/al.json';

const localeMap = { en, mk, al };

const getLangFromQuery = (search: string): Lang => {
  const params = new URLSearchParams(search);
  const langParam = params.get('lang');
  if (langParam === 'en' || langParam === 'mk' || langParam === 'al') return langParam;
  return 'mk';
};

const RaceInfoPage: React.FC = () => {
  const location = useLocation();
  const [pageLang, setPageLang] = useState<Lang>(getLangFromQuery(location.search));
  const pageT = localeMap[pageLang];

  useEffect(() => {
    const queryLang = getLangFromQuery(location.search);
    if (queryLang !== pageLang) {
      setPageLang(queryLang);
    }
  }, [location.search]);

  useEffect(() => {
    localStorage.setItem('lang', pageLang);
  }, [pageLang]);

  return (
    <PageTemplate lang={pageLang} setLang={setPageLang} t={pageT} forceScrolled={true}>
      <div
        className="race-info-page"
        style={{
          maxWidth: 600,
          margin: '0 auto',
          padding: 24,
          paddingTop: 40, // Add extra top padding for desktop
        }}
      >
        <h2>{pageT.raceInfoTitle || pageT.raceInfo || 'Race Info'}</h2>
        <ul style={{ fontSize: 20, lineHeight: 1.7, marginTop: 24 }}>
          {(pageT.raceInfoList || []).map((item: string, idx: number) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>
      {/* Run Route Video Section */}
      <div
        style={{
          maxWidth: 700,
          margin: '48px auto 0',
          padding: '16px 16px 24px 16px',
          textAlign: 'center',
          background: '#f8f8f8',
          borderRadius: 20,
          boxShadow: '0 2px 24px rgba(30,106,214,0.08)',
        }}
      >
        <h3 style={{ marginBottom: 24, fontSize: '1.5rem', fontWeight: 700, color: '#1e6ad6', letterSpacing: 1 }}>
          {pageT.runRouteVideoTitle}
        </h3>
        <video
          src={process.env.PUBLIC_URL + '/assets/run-route.mp4'}
          poster={process.env.PUBLIC_URL + '/assets/thumbnailrace.png'}
          controls
          style={{ width: '100%', borderRadius: 12, boxShadow: '0 2px 12px rgba(30,106,214,0.10)', background: '#000', marginBottom: 8 }}
        />
      </div>
    </PageTemplate>
  );
};



export default RaceInfoPage;
